<template>
  <header>
    <nav class="nav container">
        <ul class="list">
          <li data-aos="flip-left"><a href="#" class="btn btn--primary">تسجيل</a></li>
          <li data-aos="flip-right"><a href="#" class="btn btn--outline">دخول</a></li>
        </ul>
        <a data-aos="zoom-out-top" data-aos-easing="linear" data-aos-duration="2000" href="/"><img src="../assets/images/header-logo.svg" alt="logo image"></a>
    </nav>
  </header>
</template>

<script>
export default {
  name: "TheNavbar",
}
</script>

<style scoped>

</style>